<template>

    <div id="homeBox">
        <div style="  margin: 5px 0;">
            <el-date-picker style="width:210px; margin-right: 9px; margin-left: 9px;" size="mini" :clearable="false" :unlink-panels="true" v-model="searchTime" type="daterange" format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期" @change="dateChange">
            </el-date-picker>
            <el-select v-model="i_status" size="mini" @change="chooseStatus" style="margin-right: 9px;width:110px; ">
                <el-option v-for="item in stateList" :key="item.key" :label="item.label" :value="item.key"></el-option>
            </el-select>
            <el-select v-model="origin" size="mini" @change="chooseorigin" style="margin-right: 9px;width:110px; ">
                <el-option v-for="item in originList" :key="item.i_id" :label="item.vc_name" :value="item.i_id"></el-option>
            </el-select>
            <el-select v-model="path" size="mini" @change="chooseStatus" style="margin-right: 9px;width:210px; " clearable filterable>
                <el-option v-for="item in pathList" :key="item.vc_path" :label="item.vc_chinese_name" :value="item.vc_path"></el-option>
            </el-select>
            <el-select v-model="direction" size="mini" @change="chooseStatus" style="margin-right: 9px;width:140px; ">
                <el-option v-for="item in directionList" :key="item.i_direction_value" :label="item.vc_direction_name" :value="item.i_direction_value"></el-option>
            </el-select>
            <el-input style="width: 220px" class="marr4" size="mini" placeholder="搜索业务ID/参数"  v-model="vc_search">
                <el-button slot="append" icon="el-icon-search" @click="chooseStatus"></el-button>
            </el-input>
        </div>
        <el-table id="eltable" :header-cell-style="{background:'#eef1f6',color:'#000'}" ref="deliverlight" :height="tableHeight" highlight-current-row
                size="mini" :data="tableData" border style="width: 100%">
            <el-table-column  type="index" :label="$t('form_serial_number')"  width="50" show-overflow-tooltip></el-table-column>
            <el-table-column  prop="i_id" label="日志ID" show-overflow-tooltip></el-table-column>
            <el-table-column  prop="vc_methodName" label="方法名" show-overflow-tooltip></el-table-column>
<!--            <el-table-column  prop="vc_methodParameters" label="参数" show-overflow-tooltip></el-table-column>-->
            <el-table-column  prop="vc_responseMessage" label="日志" show-overflow-tooltip></el-table-column>
            <el-table-column  prop="i_retryCount" label="重试次数" show-overflow-tooltip></el-table-column>
            <el-table-column  prop="vc_caller_system" label="来源" show-overflow-tooltip></el-table-column>
<!--            <el-table-column  prop="i_origin" label="来源" show-overflow-tooltip>-->
<!--                <template  slot-scope="scope">-->
<!--                    <span v-if="scope.row.i_origin==0"  class="dib yellow">南北</span>-->
<!--                    <span v-if="scope.row.i_origin==1"  class="dib green">用友</span>-->
<!--                </template>-->
<!--            </el-table-column>-->
            <el-table-column  prop="i_direction" label="调用方向" show-overflow-tooltip>
                <template  slot-scope="scope">
                    <span v-if="scope.row.i_direction==0"  class="dib yellow">OA调用第三方</span>
                    <span v-if="scope.row.i_direction==1"  class="dib green">第三方调用OA</span>
                </template>
            </el-table-column>
            <el-table-column  prop="i_status" label="状态" show-overflow-tooltip>
                <template  slot-scope="scope">
                    <span v-if="scope.row.i_status==0"  class="dib yellow">处理中</span>
                    <span v-if="scope.row.i_status==1"  class="dib green">成功</span>
                    <span v-if="scope.row.i_status==-1" class="dib red">失败</span>
                    <span v-if="scope.row.i_status==2" class="dib blue">已重发</span>
                </template>
            </el-table-column>
            <el-table-column  prop="dt_createtime" label="创建时间" show-overflow-tooltip></el-table-column>
            <el-table-column  prop="dt_last_retry_time" label="最后一次重试时间" show-overflow-tooltip></el-table-column>
<!--            <el-table-column  prop="i_retryuid" label="重试人ID" show-overflow-tooltip></el-table-column>-->
            <el-table-column  prop="vc_retryuname" label="重试人" show-overflow-tooltip></el-table-column>
            <el-table-column
                    width="100"
                    label="操作">
                <template slot-scope="scope" >
                    <el-button  type="text" size="mini"  @click="chakan(scope.row)">查看</el-button>
                    <el-button  type="text" style="color: red" size="mini"  v-if="scope.row.isRetry==1" :disabled="scope.row.disabled" @click="chongfa(scope.row)">重发</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!--        分页器-->
        <div class="block">
            <div class="pages">
                <div class="choosepage flexother  fl">
                    <el-pagination
                            small
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="this.currentPage"
                            :page-sizes="[10, 20, 30, 40]"
                            :page-size="this.pageSize"
                            layout="total,sizes"
                            :total="this.total"
                    >
                    </el-pagination>
                    <el-pagination
                            small
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="this.currentPage"
                            :pager-count="5"
                            :page-size="this.pageSize"
                            layout="prev, pager, next, jumper"
                            :total="this.total">

                    </el-pagination>
                </div>

            </div>
        </div>
        <el-dialog
                :class="baseerp+'div'"
                :close-on-click-modal="false"
                style="display: flex;justify-content: center;align-items: center;color: black;font-weight: bold"
                top="7%"
                width="80%"
                height="300"
                title="查看详情"
                :visible.sync="detailDialog"
                v-if="detailDialog"
        >
            <detail-page :data="detailData" @close="closeDetail"></detail-page>
        </el-dialog>
    </div>
</template>

<script>
    import {baseerp} from "@/utils/baseUrl";
    import * as API from "./api";
    import {mapActions} from "vuex";
    import DetailPage from "./component/DetailPage";

    export default{
        name:'APIcallLogs',
        components:{
            DetailPage,

        },

        data(){
            return{
                i_status:-1,
                stateList:[{key:'',label:'全部'},{key:0,label:'处理中'},{key:1,label:'成功'},{key:-1,label:'失败'},{key:2,label:'已重发'}],
                origin:0,
                originList:[
                    // {key:0,label:'南北'},{key:1,label:'用友'}
                    ],
                path:'',
                pathList:[],
                direction:0,
                directionList:[],
                currentPage:1,
                pageSize:10,
                total:0,
                baseerp:'',
                tableData: [],
                tableHeight:0,//列表高度
                detailDialog:false,
                detailData:{},
                searchTime:[],
                i_pid:'',
                vc_search:'',
            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    // console.log(n,12312312)
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },

        mounted(){
            this.$nextTick(()=>{
                this.onResize();

            })
            this.getDay()
            this.getExternalSystem()
            this.getApiCallDirection()
            //公共样式
            this.baseerp=baseerp
            // this.$nextTick(function () {
            //     this.heightAuto();
            // window.addEventListener('resize',this.onResize);

            // });

        },

        beforeDestroy() {
            // window.removeEventListener('resize',this.heightAuto)
        },
        methods:{
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-80

                // console.log(this.tableHeight)
                // $('.contentRight').width($("#homeBox").width() - $('.contentLeft').width() - 5 );
                // this.$refs.spread_Edit.onResize();
            },
            ...mapActions(["getCurrentMenuId"]),
            //高度

            heightAuto(){
                // this.$nextTick(()=>{
                //     document.getElementById('body').getBoundingClientRect().top
                // })
                this.tableHeight = window.innerHeight - document.getElementById('body').getBoundingClientRect().top -48 -36    ;

                // console.log(this.tableHeight)
                // console.log(document.getElementById('body').getBoundingClientRect().top)
                // console.log(window.innerHeight)
                // console.log()
            },


            //关闭弹框
            // close(){
            //     this.detailDialog=false
            // },
            //页面搜索
            chooseorigin(){
                this.path='';
                this.getInterfaceList()
                this.currentPage=1
                this.getApiLogList()
            },
            chooseStatus(){
                this.currentPage=1
                this.getApiLogList()

            },
            dateChange(){
                this.startTime=this.searchTime[0]
                this.endTime=this.searchTime[1]
                this.currentPage=1;
                this.getApiLogList();
            },
            chongfa(val){
                this.$confirm('是否继续重发','提示',{
                    confirmButtonText:'继续',
                    cancelButtonText:'取消',
                    type:'warning'
                }).then(async()=>{
                    this.retry(val)
                }).catch(()=>{
                    this.$message({
                        type:'info',
                        message:'已取消'
                    })
                })
            },
            //分页
            handleSizeChange(val) {
                // console.log(`每页 ${val} 条`);
                this.pageSize = val;    //动态改变
                this.getApiLogList()
            },
            handleCurrentChange(val) {
                // console.log(`当前页: ${val}`);
                this.currentPage = val;    //动态改变
                this.getApiLogList()
            },
            chakan(val){
                this.detailData=val
                this.detailDialog=true
            },
            closeDetail(){
                this.detailDialog=false
                this.detailData=null
            },
            //业务配置列表查询
            async getApiLogList() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    search:this.Searchdata,
                    currentPage: this.currentPage,
                    pageSize: this.pageSize,
                    createTimeStart:this.startTime+' 00:00:00',
                    createTimeEnd:this.endTime+' 23:59:59',
                    i_pid:this.i_pid,
                    status:this.i_status,
                    origin:this.origin,
                    direction:this.direction,
                    vc_search:this.vc_search,
                    vc_methodName:this.path,
                }
                let res = await API.getApiLogList(params);
                if (res.code == 1) {
                    this.tableData=res.data
                    this.total=res.total
                    // console.log(res)
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },

            async retry(val) {
                val.disabled=true
                let params = {
                    i_id:val.i_id,
                    vc_methodName:val.vc_methodName,
                    vc_methodParameters:val.vc_methodParameters,
                    i_retryuid:sessionStorage.getItem("userid"),
                    vc_retryuname:sessionStorage.getItem("lruname"),
                    i_direction:val.i_direction,
                    i_origin:val.i_origin,
                    vc_ywid:val.vc_ywid,
                    i_interface_id:val.i_interface_id,

                }
                let res = await API.retry(params);
                if (res.code == 1) {
                    this.$message.success(res.message);
                    this.getApiLogList()
                    val.disabled=false

                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    val.disabled=false

                    this.$message.error(res.message);
                }
            },
            getDay(){
                const date=new Date();
                const y=date.getFullYear()
                const m=(date.getMonth()+1).toString().padStart(2,'0');
                const prem=date.getMonth().toString().padStart(2,'0');
                const d=date.getDate().toString().padStart(2,'0');
                this.startTime=y+'-'+m+'-'+'01';
                this.endTime=y+'-'+m+'-'+d;
                this.preMDate=y+'-'+prem+'-'+d;
                this.searchTime=[ this.startTime,this.endTime]
            },
            getDateString(date){
                let data=date;
                let day=data.substring(0,10);
                // console.log(day,this.preMDate)
                // console.log(day>=this.preMDate)
                if(day>=this.preMDate){
                    return true
                }else {
                    return false
                }
            },
            async getExternalSystem() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {

                }
                let res = await API.getExternalSystem(params);
                if (res.code == 1) {
                    this.originList=res.data;
                    this.origin=this.originList[0].i_id;
                    this.getInterfaceList()
                    this.getApiLogList()
                    // console.log(res)
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            async getInterfaceList() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    i_pid:this.origin,
                }
                let res = await API.getInterfaceList(params);
                if (res.code == 1) {
                    this.pathList=res.data

                    // console.log(res)
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            async getApiCallDirection() {

                let params = {
                    i_pid:this.origin,
                }
                let res = await API.getApiCallDirection(params);
                if (res.code == 1) {
                    this.directionList=res.data

                    // console.log(res)
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
        },

    }
</script>
<style lang="scss" scoped>
    .flexcenter{
        min-width: 39.286rem;
        width: 100%;
        height: 2.857rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 0.857rem;
    }
    /deep/{
        .el-table--enable-row-transition{
            /*min-width: 53.571rem !important;*/
        }
        .el-button--text{
            padding: 0 !important;
            margin-left: 0 !important;
            margin-right: 10px;
        }
        .el-tabs__content{
            /*height: 90% !important;*/
            overflow: visible !important;
            height:calc(100% - 0.357rem) !important;
        }
    }
    /deep/.is-leaf .cell .el-checkbox__input{
        display: none;
    }
    .m{
        padding-top: 1.429rem;
    }
    .flexother {
        display: flex;
        /*flex-flow: wrap;*/
        justify-content: flex-end;
        align-items: center;
    }
    .fl{
        float: left;
        .el-button--primary{
            color: #efd773;
            background-color:white;
            border: 0;
            text-align: center;
            padding: 0;
            height: 2rem;
            width: 3.286rem;
            margin:0.857rem 0 0 0.714rem;
        }
    }

    .fr{
        float:right;
    }

    .cl{
        clear: both;
    }
    .input{
        width: 14.286rem;
    }
    /*.mrt20{*/
    /*    margin-top: 1.429rem;*/
    /*}*/
    .mrl20{
        margin-left: 1.429rem;
    }
    .mrb20{
        margin-right: 1.429rem;
    }
    .mrr20{
        margin-right: 1.429rem;
    }

    .chooseheader{
        width:100%;
    }

    .choosepage{
        /*min-width: 42.571rem;*/
        width:90%
    }
    .left{
        width: 17.857rem;
    }
    .red{
        color: red;
    }
    .green{
        color: green;
    }
    .yellow{
        color: #ffbe06;
    }
    .blue{
        color: #409EFF;
    }
</style>